import { apiRequest } from 'api/apiClient';

// Location Groups
const fetchLocationGroups = async () => {
  const response = await apiRequest('GET', '/v1/location-groups', null);
  return response;
};

const fetchLocationGroupDetail = async (uid) => {
  const response = await apiRequest('GET', `/v1/location-groups/${uid}`, null);
  return response;
};

const fetchAvailableLocations = async () => {
  const response = await apiRequest('GET', '/v1/location-groups/available-locations', null);
  return response;
};

// Locations
const fetchLocations = async (regionUid) => {
  const response = await apiRequest('GET', '/v1/locations', null, {
    params: {
      ...(regionUid ? { region: regionUid } : {}),
    },
  });
  return response;
};

const fetchLocation = async (locationUid) => {
  const response = await apiRequest('GET', `/v1/locations/${locationUid}`, null);
  return response;
};

const fetchRetailerLocation = async (locationUid) => {
  const response = await apiRequest('GET', `/v1/locations/${locationUid}`, null);
  return response;
};

const fetchLocationAvailableUsers = async (locationUid) => {
  const response = await apiRequest('GET', `/v1/locations/${locationUid}/available-users`, null);
  return response;
};

const fetchLocationAvailableLooks = async (locationUid) => {
  const response = await apiRequest('GET', `/v1/locations/${locationUid}/available-looks`, null);
  return response;
};

const fetchLocationAvailableBanners = async (locationUid) => {
  const response = await apiRequest('GET', `/v1/locations/${locationUid}/available-banners`, null);
  return response;
};

const fetchLocationAvailableVideos = async (locationUid) => {
  const response = await apiRequest('GET', `/v1/locations/${locationUid}/available-videos`, null);
  return response;
};

const fetchLocationAvailableParticipants = async (locationUid) => {
  const response = await apiRequest(
    'GET',
    `/v1/locations/${locationUid}/available-participants`,
    null,
  );
  return response;
};

const fetchLocationAvailableEvents = async (locationUid) => {
  const response = await apiRequest('GET', `/v1/locations/${locationUid}/available-events`, null);
  return response;
};

const fetchLocationAvailableModulesContent = async (locationUid) => {
  const response = await apiRequest(
    'GET',
    `/v1/locations/${locationUid}/available-page-modules-content`,
    null,
  );
  return response;
};

const LOCATIONS_QUERIES = {
  // Location Groups
  FETCH_LOCATION_GROUPS: fetchLocationGroups,
  FETCH_LOCATION_GROUP_DETAIL: fetchLocationGroupDetail,
  FETCH_AVAILABLE_LOCATIONS: fetchAvailableLocations,

  // Locations
  FETCH_LOCATIONS: fetchLocations,
  FETCH_LOCATION: fetchLocation,
  FETCH_RETAILER_LOCATION: fetchRetailerLocation,
  FETCH_LOCATION_AVAILABLE_USERS: fetchLocationAvailableUsers,
  FETCH_LOCATION_AVAILABLE_LOOKS: fetchLocationAvailableLooks,
  FETCH_LOCATION_AVAILABLE_BANNERS: fetchLocationAvailableBanners,
  FETCH_LOCATION_AVAILABLE_VIDEOS: fetchLocationAvailableVideos,
  FETCH_LOCATION_AVAILABLE_PARTICIPANTS: fetchLocationAvailableParticipants,
  FETCH_LOCATION_AVAILABLE_EVENTS: fetchLocationAvailableEvents,
  FETCH_LOCATION_AVAILABLE_MODULES_CONTENT: fetchLocationAvailableModulesContent,
};

export default LOCATIONS_QUERIES;
